<template>
  <v-menu ref="menu" v-model="menu" :close-on-content-click="false" :return-value.sync="date"
    transition="scale-transition" offset-y min-width="auto">
    <template v-slot:activator="{ on, attrs }">
      <v-text-field :hide-details="hideDetails" outlined dense v-model="_date" :label="label" clearable readonly v-bind="attrs" v-on="on"></v-text-field>
    </template>
    <v-date-picker range v-model="date" no-title scrollable>
      <v-spacer></v-spacer>
      <v-btn text color="primary" @click="menu = false">
        Cancel
      </v-btn>
      <v-btn text color="primary" @click="$refs.menu.save(date)">
        OK
      </v-btn>
    </v-date-picker>
  </v-menu>
</template>

<script>
export default {
  props: ['value', 'label', 'range', 'hideDetails'],
  data() {
    return {
      date: this.value,
      menu: false
    }
  },
  computed: {
    _date: {
      get() {
        return this.date
      },
      set(value) {
        this.date = [];
      }
    },
  },
  watch: {
    date: function (value) {
      if (value) {
        this.$emit('update:value', value)
      }
      else {
        this.$emit('update:value', [])
      }
    }
  }
}
</script>